module.exports = __webpack_public_path__ + "img/blocking-bg.9c054ad2.svg";